module.exports = __webpack_public_path__ + "static/media/drive_car1.ccce7e86.jpg";